"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckPhoneNumberRequestPayloadToJSON = exports.CheckPhoneNumberRequestPayloadFromJSONTyped = exports.CheckPhoneNumberRequestPayloadFromJSON = void 0;
function CheckPhoneNumberRequestPayloadFromJSON(json) {
    return CheckPhoneNumberRequestPayloadFromJSONTyped(json, false);
}
exports.CheckPhoneNumberRequestPayloadFromJSON = CheckPhoneNumberRequestPayloadFromJSON;
function CheckPhoneNumberRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'input': json['input'],
    };
}
exports.CheckPhoneNumberRequestPayloadFromJSONTyped = CheckPhoneNumberRequestPayloadFromJSONTyped;
function CheckPhoneNumberRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'input': value.input,
    };
}
exports.CheckPhoneNumberRequestPayloadToJSON = CheckPhoneNumberRequestPayloadToJSON;
//# sourceMappingURL=CheckPhoneNumberRequestPayload.js.map